// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"glmeqGXg","ButtonSkeleton":"Jp9ArfmX","IconPlaceholder":"RxDqj_FQ","Option":"Jitqawrf","Content":"lvRQZr3i","Label":"HYUkgCMh","CheckIconContainer":"lzk0EIMI"};